<template>
  <div class="container bg-light">
    <div class="row justify-content-center">
      <div class="col">
        <h1>Debug</h1>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Timestamp</th>
              <th scope="col">Description</th>
              <th scope="col" class="text-center">Evasion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, i) in sortedDebugLogEntries" :key="i">
              <th scope="row">{{ formatter.timestamp.relative(entry.timestamp) }}</th>
              <td>
                <div style="white-space: pre-wrap">{{ entry.description }}</div>
              </td>
              <td class="text-center">
                <span :title="entry.evasionDescription">
                  <fa class="text-danger" v-if="entry.evasionDetected" icon="exclamation-circle" />
                  <span v-if="!entry.evasionDetected">---</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
  props: {
    debugLogEntries: Array,
  },
  computed: {
    formatter() {
      return formatter;
    },
    sortedDebugLogEntries() {
      if (this.debugLogEntries == null || this.debugLogEntries.length == 0) return null;
      var temp = this.debugLogEntries.map(e => e); // temp copy, becuase .sort() modifies the array
      temp.sort((x, y) => {
        if (x.timestamp > y.timestamp) return -1;
        if (x.timestamp < y.timestamp) return 1;
        return 0;
      });
      return temp;
    },
  },
};
</script>
